module.exports = __webpack_public_path__ + "assets/img/a774bfb6f3bbc692e2dd754a4a3cafe2.svg";